import { useState, useEffect } from "react";
import { supabaseStore } from "@/lib/supabaseStore";

export function useSupabase() {
  const [isSupabaseReady, setIsSupabaseReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    checkSupabaseConnection();
  }, []);

  const checkSupabaseConnection = async () => {
    try {
      setIsLoading(true);
      setError(null);

      console.log("🔍 Testing Supabase connection...");

      // Test Supabase connection by trying to fetch a simple query
      const { data, error } = await supabaseStore.supabase
        .from("judges")
        .select("count")
        .limit(1);

      if (error) {
        console.error("❌ Supabase query test failed:", error);
        throw new Error(`Supabase query failed: ${error.message}`);
      }

      console.log("✅ Supabase query test successful");
      setIsSupabaseReady(true);
    } catch (err: any) {
      console.error("❌ Supabase connection failed:", err);

      let userFriendlyMessage = "Erro de conexão com o banco de dados";

      if (err?.message?.includes("Failed to fetch")) {
        userFriendlyMessage =
          "Erro de rede: Verifique sua conexão com a internet";
      } else if (err?.code === "PGRST301") {
        userFriendlyMessage =
          "Autenticação do banco falhou - Verifique a API key";
      } else if (err?.code === "PGRST116") {
        userFriendlyMessage = "Tabelas do banco não encontradas";
      } else if (err?.message) {
        userFriendlyMessage = err.message;
      }

      setError(userFriendlyMessage);
      setIsSupabaseReady(false);
    } finally {
      setIsLoading(false);
    }
  };

  const retryConnection = () => {
    checkSupabaseConnection();
  };

  return {
    isSupabaseReady,
    isLoading,
    error,
    retryConnection,
    store: supabaseStore,
    isConnected: isSupabaseReady,
  };
}
